'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransactionalButton = require('./components/TransactionalButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransactionalButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/transactional/index.js
// module id = 1054
// module chunks = 1